import React from 'react'
import Flow from 'procedures/Flow'
import {get, isEmpty} from 'lodash'

export const makeFlow = function* (employee) {
  if (isEmpty(employee) || isEmpty(employee.office)) {
    return
  }
  const healthInsuranceJoined = get(employee, 'health_insurance.joined')
  const welfarePensionInsuranceJoined = get(employee, 'welfare_pension_insurance.joined')
  const healthInsuranceType = get(employee, 'office.health_insurance_type')
  if (healthInsuranceJoined || welfarePensionInsuranceJoined) {
    yield 'R14'
  }
  if (healthInsuranceType === 'its' && healthInsuranceJoined) {
    yield 'R147'
  }
}

const ChangeAddressFlow = ({location, match}) => <Flow {...{makeFlow, location, match}} />

export default ChangeAddressFlow
